export const mainLayoutPaddingX = { base: "2", lg: "8", "2xl": "32" };
